import React, { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { lblStyle } from "./waShared";

// ─── Auto-Reply Settings Panel (v119.55) ─────────────────────────────
// Settings for the after-hours AI auto-reply feature. When enabled,
// any inbound customer message outside operating hours triggers a
// Claude-generated reply with a clear «🤖 رد آلي» prefix.
function AutoReplyPanel() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/whatsapp/auto-reply");
      setSettings(r.data || {});
    } catch (_e) { setSettings({}); }
  }, []);
  useEffect(() => { load(); }, [load]);

  if (!settings) return <div className="card" style={{ padding: 20, textAlign: "center" }}>⏳ جارٍ التحميل...</div>;

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/whatsapp/auto-reply", settings);
      toast.success("تم الحفظ");
    } catch (e) { toast.error(e?.response?.data?.detail || "فشل الحفظ"); }
    finally { setSaving(false); }
  };

  const set = (k, v) => setSettings((s) => ({ ...s, [k]: v }));

  return (
    <div className="card" style={{ padding: 14 }} data-testid="wa-autoreply-panel">
      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8, color: "var(--brown-deep)" }}>
        🤖 إعدادات الرد الآلي خارج ساعات العمل
      </div>
      <p style={{ fontSize: 11.5, color: "var(--muted)", marginBottom: 14, lineHeight: 1.7 }}>
        عند وصول أي رسالة WhatsApp خارج ساعات العمل المحدّدة، يُحلّلها AI ويُرسل ردّاً ودوداً مع بادئة واضحة «🤖 رد آلي». مثالية للحفاظ على تجربة العميل حتى خارج الدوام.
      </p>
      <div style={{ display: "grid", gap: 10 }}>
        <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <input type="checkbox" checked={!!settings.enabled} onChange={(e) => set("enabled", e.target.checked)} data-testid="wa-ar-enabled" />
          <span style={{ fontSize: 12.5, fontWeight: 700 }}>تفعيل الرد الآلي</span>
        </label>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          <div>
            <label style={lblStyle}>ساعة فتح المقهى (24h)</label>
            <input type="number" min="0" max="23" className="sim-input"
              value={settings.open_hour ?? 7}
              onChange={(e) => set("open_hour", Number(e.target.value))} data-testid="wa-ar-open" />
          </div>
          <div>
            <label style={lblStyle}>ساعة الإغلاق</label>
            <input type="number" min="0" max="23" className="sim-input"
              value={settings.close_hour ?? 23}
              onChange={(e) => set("close_hour", Number(e.target.value))} data-testid="wa-ar-close" />
          </div>
        </div>
        <div>
          <label style={lblStyle}>الحد الأقصى للردود لنفس الرقم/اليوم</label>
          <input type="number" min="1" max="10" className="sim-input"
            value={settings.max_replies_per_phone_per_day ?? 1}
            onChange={(e) => set("max_replies_per_phone_per_day", Number(e.target.value))}
            data-testid="wa-ar-cap" />
        </div>
        <div>
          <label style={lblStyle}>البادئة الثابتة (لتوضيح أن الرد آلي)</label>
          <textarea className="sim-input" rows={2}
            value={settings.prefix || ""} onChange={(e) => set("prefix", e.target.value)}
            data-testid="wa-ar-prefix" />
        </div>
        <button type="button" onClick={save} disabled={saving}
          className="btn btn-dark" style={{ fontSize: 13 }} data-testid="wa-ar-save">
          {saving ? "⏳ يحفظ..." : "💾 حفظ الإعدادات"}
        </button>
      </div>
    </div>
  );
}

export default AutoReplyPanel;
